import { useMutation } from '@tanstack/react-query';
import { extractPartnerDetailsFromPrompt } from '../services/extractPartnerDetails';

/** POST /admin/extract-partner-details */
export const useExtractPartnerDetailsMutation = (options = {}) => {
  const { onSuccess, onError, ...restOptions } = options;

  return useMutation({
    mutationFn: async (prompt) => {
      const result = await extractPartnerDetailsFromPrompt(prompt);
      if (!result.success) {
        throw new Error(result.message || 'Failed to extract partner details');
      }
      return result;
    },
    onSuccess: async (data, variables, context) => {
      await onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      onError?.(error, variables, context);
    },
    ...restOptions,
  });
};
